var map = {
	"./en.json": [
		"./projects/student/target/annotated/app/common/translate/en.json",
		[
			319
		]
	],
	"./en.vendor.json": [
		"./projects/student/target/annotated/app/common/translate/en.vendor.json",
		[
			342
		]
	],
	"./fi.json": [
		"./projects/student/target/annotated/app/common/translate/fi.json",
		[
			229
		]
	],
	"./fi.vendor.json": [
		"./projects/student/target/annotated/app/common/translate/fi.vendor.json",
		[
			720
		]
	],
	"./sv.json": [
		"./projects/student/target/annotated/app/common/translate/sv.json",
		[
			125
		]
	],
	"./sv.vendor.json": [
		"./projects/student/target/annotated/app/common/translate/sv.vendor.json",
		[
			520
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./projects/student/target/annotated/app/common/translate lazy recursive ^\\.\\/.*\\.json$ include: \\.json$";
module.exports = webpackAsyncContext;